import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[pageGenericToolbarCustomItem]",
  standalone: false
})
export class PageGenericToolbarCustomItemDirective {
  @Input("pageGenericToolbarCustomItem") position: "start" | "end" = "start";

  constructor(
    public templateRef: TemplateRef<any>,
    public viewContainer: ViewContainerRef
  ) {}
}
